import type { TFunction } from "i18next";
import type { CivilShelterInfo } from "../MapModel";

export interface ShelterDetailRow {
  key: "status" | "capacity" | "ownership" | "locality" | "address";
  label: string;
  value: string;
  unit?: string;
  tone?: "functional" | "partial" | "nonfunctional";
}

export function mapShelterDetails(shelter: CivilShelterInfo | undefined, address: string, t: TFunction, locale = "ro") {
  const rows: ShelterDetailRow[] = [];
  const statusTones = { functional: "functional", partial_functional: "partial", nefunctional: "nonfunctional" } as const;
  if (shelter?.stare && Object.prototype.hasOwnProperty.call(statusTones, shelter.stare)) {
    rows.push({ key: "status", label: t("map.shelter.shortStatus"), value: t(`map.shelter.${shelter.stare}`), tone: statusTones[shelter.stare] });
  }
  if (typeof shelter?.capacitate === "number" && Number.isFinite(shelter.capacitate) && shelter.capacitate >= 0) {
    rows.push({ key: "capacity", label: t("map.shelter.capacity"), value: new Intl.NumberFormat(locale).format(shelter.capacitate), unit: t("map.shelter.peopleUnit", { count: shelter.capacitate }) });
  }
  if (typeof shelter?.proprietate_publica === "boolean") {
    rows.push({ key: "ownership", label: t("map.shelter.ownership"), value: t(`map.shelter.${shelter.proprietate_publica ? "public" : "private"}`) });
  }
  const locality = shelter?.localitate?.trim();
  if (locality) rows.push({ key: "locality", label: t("map.shelter.locality"), value: locality });
  rows.push({ key: "address", label: t("map.shelter.address"), value: address.trim() || t("components.responsiveModal.noAdress") });
  return rows;
}
